<template>
  <div class="similarity-problem">
    <titleImg :icon="require('images/qa/questions/similar-title.png')" />
    <ul class="problem-list">
      <li class="problem-item" v-for="item in problems" :key="item.id">
        <div class="item-url" @click="toDetailUrl(item)">
          <div class="problem-item-top">
            <img
              src="~images/platform/mutualHelp/v3/question-item-icon.png"
              alt=""
            />
            {{ item.title }}
          </div>
          <div class="problem-item-bottom">
            <span class="problem-item-num"
              >{{ item.commentnum }}回答 ·
              {{ formatDate(item.created, 'Y.M.D h:m:s') }}</span
            >
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import titleImg from 'component/qa/title.vue'
import { formatDate } from 'utils/index.js'
export default {
  components: {
    titleImg
  },
  props: {
    problems: {
      type: Array,
      default: () => []
    }
  },
  inject: ['questionTags'],
  methods: {
    formatDate,
    toDetailUrl(item) {
      const { env } = this.$runningEnv
      const s = env ? `-${env}` : ''
      const pathUrl = `https://m${s}.xinli001.com/qa/${item.id}?hideNavigationBar=1&node=1`
      this.routerPush(pathUrl)
    },
    toDetail(item) {
      this.$trackEvent('qa_question_details_other_question', {
        ...this.questionTags,
        qa_id: item.id
      })
      // if (this.$platform.isYixinliApp) {
      //   this.routerPush({
      //     path: `/qa/${item.id}?hideNavigationBar=1&node=1`
      //   })
      // } else {
      //   const { env } = this.$runningEnv
      //   const s = env ? `-${env}` : ''
      //   window.location.href = `https://m${s}.xinli001.com/qa/${item.id}?hideNavigationBar=1&node=1`
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.similarity-problem {
  background-color: #fff;
  padding: 36px 32px 40px 32px;
  box-sizing: border-box;
  .problem-item {
    box-sizing: border-box;
    border-bottom: 1px solid #f3f4f5;
    &:last-child {
      border: none;
      .item-url {
        padding-bottom: 0;
      }
    }
    .item-url {
      display: block;
      padding: 30px 0;
      box-sizing: border-box;
    }
  }
  .problem-item-top {
    font-size: 34px;
    line-height: 50px;
    font-weight: 600;
    color: #21252d;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    img {
      width: 38px;
      height: 38px;
      object-fit: cover;
      margin-right: 7px;
      flex-shrink: 0;
      float: left;
      margin-top: 6px;
    }
  }
  .problem-item-bottom {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    margin-top: 20px;
    .problem-item-num {
      font-size: 26px;
      font-weight: 400;
      color: #9da3ac;
    }
    .problem-item-date {
      font-size: 26px;
      font-weight: 400;
      color: #9da3ac;
    }
  }
}
</style>
